"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useForceUpdate() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [, forceUpdate] = react_1.useReducer((x, _) => x + 1, 0);
    return forceUpdate;
}
exports.default = useForceUpdate;
//# sourceMappingURL=forceUpdate.js.map